import React from 'react';
import Header from 'components/Header';
import './nomatch.less';
import {useTranslation} from "react-i18next";

const NoMatch = (props) => {

    const {t} = useTranslation()

    return(
        <div className="authentication-scene full-height--with-policy flex-column row">
        <Header {...props} />

        <div className="error-page col flex-fill justify-content-center align-items-center">
            <div className="col">
                <h1 data-h1="404">404</h1>
                <p data-p="Sorry :(">{t("lbl.SORRY","Sorry")} :( </p>
                <p data-p="The page you are looking for doesn't exist anymore!">{t("lbl.PAGE_NOT_EXISTENT","The page you are looking for doesn't exist anymore!")}</p>
            </div>
        </div>
    </div>
    );
}

export default NoMatch;